export const getReputationsScript = `
import Reputation from 0x6c0d53c676256e8c

pub fun main(account: Address): {UInt8: UFix64} {
    let identity = getAccount(account).getCapability(/public/ReputationIdentity)
                      .borrow<&Reputation.Identity{Reputation.IdentityPublic}>()
                      ?? panic("Could not borrow the receiver's identity.")
  
    let reputations = identity.getReputations()
  
    let returnVal: {UInt8: UFix64} = {}

    if let education = reputations[Reputation.ReputationTypes.Education] {
        returnVal[0] = education
    } else {
        returnVal[0] = 0.0
    }

    if let treasury = reputations[Reputation.ReputationTypes.Treasury] {
        returnVal[1] = treasury
    } else {
        returnVal[1] = 0.0
    }

    if let technical = reputations[Reputation.ReputationTypes.Technical] {
        returnVal[2] = technical
    } else {
        returnVal[2] = 0.0
    }

    if let artwork = reputations[Reputation.ReputationTypes.Artwork] {
        returnVal[3] = artwork
    } else {
        returnVal[3] = 0.0
    }

    return returnVal
}
`

export const getIdentityTx = `
import Reputation from 0x6c0d53c676256e8c

transaction() {

  prepare(acct: AuthAccount) {
    acct.save(<- Reputation.createIdentity(), to: /storage/ReputationIdentity)
    acct.link<&Reputation.Identity{Reputation.IdentityPublic, Reputation.IdentityGovernor}>(/public/ReputationIdentity, target: /storage/ReputationIdentity)
  }

  execute {
    log("Stored Identity.")
  }
}
`

export const giveReputationTx = `
import Reputation from 0x6c0d53c676256e8c

transaction(receiver: Address, amount: UFix64, reputationType: UInt8) {

  let Governor: &Reputation.Governor
  let ReceiverIdentity: &Reputation.Identity{Reputation.IdentityGovernor}

  prepare(acct: AuthAccount) {
    self.Governor = acct.borrow<&Reputation.Governor>(from: /storage/ReputationGovernor)
                      ?? panic("Could not borrow the Governor.")

    self.ReceiverIdentity = getAccount(receiver).getCapability(/public/ReputationIdentity)
                              .borrow<&Reputation.Identity{Reputation.IdentityGovernor}>()
                              ?? panic("Could not borrow the receiver's identity.")
    
  }

  execute {
    self.Governor.giveReputation(reputationTypeRV: reputationType, amount: amount, identity: self.ReceiverIdentity)
    log("Gave reputation.")
  }
}
`